import { Component, Input, OnInit } from '@angular/core';
import { DateFormatType} from '@core';
import { ModalRef } from '@core-lib/modules/modal-container';
import { IHistorique } from '@core-lib/models/history.model';

@Component({
    selector: 'history-modal',
    templateUrl: './history-modal.component.html',
    standalone: false
})
export class HistoryModalComponent implements OnInit {
	@Input() selectedHistorique: IHistorique[];
	@Input() title: string;
	dateFormatType = DateFormatType;

	constructor(private modalRef: ModalRef) {}

	ngOnInit(): void {}

	onClose(): void {
		this.modalRef.hide();
	}
}
